import React, { useEffect, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

import colaboradoresService from '../../services/colaboradores.service'
import dashboardService from '../../services/dashboard.service'

const contagemVazia = { totalClinicos: 0, totalOrtodontia: 0, total: 0 }

export default function TransferirResponsavelEmMassaModal({ show, onHide, colaboradorOrigem, onSuccess }) {
  const [colaboradores, setColaboradores] = useState([])
  const [novoColaborador, setNovoColaborador] = useState(null)
  const [contagem, setContagem] = useState(contagemVazia)
  const [salvando, setSalvando] = useState(false)
  const [carregando, setCarregando] = useState(false)

  useEffect(() => {
    if (!show || !colaboradorOrigem?.id) return

    setNovoColaborador(null)
    setContagem(contagemVazia)
    setCarregando(true)

    Promise.all([
      colaboradoresService.getAllColaboradores(),
      dashboardService.contarPlanosResponsavel(colaboradorOrigem.id),
    ])
      .then(([colaboradoresResponse, contagemResponse]) => {
        setColaboradores(
          (colaboradoresResponse.data || [])
            .filter((c) => c.ativo)
            .map(({ nome, id }) => ({ label: nome, value: id }))
        )
        setContagem({
          totalClinicos: contagemResponse?.totalClinicos || 0,
          totalOrtodontia: contagemResponse?.totalOrtodontia || 0,
          total: contagemResponse?.total || 0,
        })
      })
      .catch(() => toast.error('Erro ao carregar dados da transferência.'))
      .finally(() => setCarregando(false))
  }, [show, colaboradorOrigem])

  const opcoes = colaboradores.filter((c) => c.value !== colaboradorOrigem?.id)

  const handleConfirmar = async () => {
    if (!colaboradorOrigem?.id || !novoColaborador?.value) {
      toast.error('Selecione o novo colaborador responsável.')
      return
    }

    if (!contagem.total) {
      toast.warning('Não há tratamentos para transferir para este colaborador.')
      return
    }

    setSalvando(true)
    try {
      const resultado = await dashboardService.transferirResponsavelEmMassa({
        colaboradorOrigemId: colaboradorOrigem.id,
        colaboradorDestinoId: novoColaborador.value,
      })
      toast.success(
        `Transferência concluída: ${resultado?.total || contagem.total} tratamento(s) ` +
          `(${resultado?.totalClinicos || contagem.totalClinicos} clínicos, ` +
          `${resultado?.totalOrtodontia || contagem.totalOrtodontia} ortodontia).`
      )
      onHide()
      if (onSuccess) await onSuccess()
    } catch (error) {
      const mensagem =
        (typeof error?.response?.data?.errors === 'string' && error.response.data.errors) ||
        error?.response?.data?.mensagemErro ||
        error?.response?.data?.message ||
        'Erro ao transferir responsáveis em massa.'
      toast.error(mensagem)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Modal show={show} onHide={salvando ? undefined : onHide} centered>
      <Modal.Header closeButton={!salvando}>
        <Modal.Title>Transferir responsável em massa</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {colaboradorOrigem && (
          <>
            <p className='mb-1 text-uppercase'>
              <b>De:</b> {colaboradorOrigem.nome}
            </p>
            <p className='mb-3'>
              Serão transferidos{' '}
              <b>{carregando ? '...' : contagem.total}</b> tratamento(s)
              {!carregando && (
                <>
                  {' '}
                  (<b>{contagem.totalClinicos}</b> clínicos e <b>{contagem.totalOrtodontia}</b> ortodontia)
                </>
              )}
              , em que este colaborador é o responsável atual.
            </p>
            <Form.Group>
              <Form.Label>Novo responsável (ativos)</Form.Label>
              <Select
                placeholder={carregando ? 'Carregando...' : 'Selecione o colaborador'}
                options={opcoes}
                value={novoColaborador}
                onChange={setNovoColaborador}
                noOptionsMessage={() => 'Nenhum colaborador ativo'}
                isDisabled={salvando || carregando}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide} disabled={salvando}>
          Cancelar
        </Button>
        <Button
          variant='primary'
          onClick={handleConfirmar}
          disabled={!novoColaborador || salvando || carregando || !contagem.total}
        >
          {salvando ? 'Transferindo...' : 'Confirmar transferência'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
